"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useExternalAuth = exports.externalAuthContext = exports.ExternalAuthProvider = void 0;
var _auth = require("@ori/auth");
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _logger = require("@ori/logger");
var _react = require("react");
var _constants = require("../constants");
var _utils = require("../utils");
var _authUtils = require("../utils/authUtils");
var _jsxRuntime = require("react/jsx-runtime");
const externalAuthContext = exports.externalAuthContext = /*#__PURE__*/(0, _react.createContext)({
  codeVerifier: ''
});
const {
  Provider
} = externalAuthContext;
const ExternalAuthProvider = ({
  children
}) => {
  // istanbul ignore next @preserve -- No need to test undefined tenant case.
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    identityUrl
  } = (0, _configurationManager.useServiceUrls)(['identity']);
  const {
    isAnonymousUser,
    isUserVerified
  } = (0, _auth.useToken)();
  const localLogger = (0, _logger.useLogger)('ExternalAuthProvider');
  const [codeVerifier, setCodeVerifier] = (0, _react.useState)('');
  (0, _react.useEffect)(() => {
    const handleMessage = event => {
      if (event.data.source === 'genesysAuth' && event.data.code && event.data.iss) {
        localStorage.setItem(_constants.AUTH_CODE_STORAGE_PARAMETER_FOR_GENESYS, event.data.code);
        localStorage.setItem(_constants.ISSUER_STORAGE_PARAMETER_FOR_GENESYS, event.data.iss);
        document.getElementById(_constants.AUTH_IFRAME_ID)?.remove();
      }
    };
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);
  (0, _react.useEffect)(() => {
    if (!isAnonymousUser && isUserVerified) {
      // istanbul ignore next @preserve -- No need to test setup of iframe.
      (0, _authUtils.generateVerifierAndChallenge)().then(({
        codeChallenge,
        codeVerifier: newCodeVerifier
      }) => {
        const authUrl = (0, _utils.generateAuthUrl)({
          codeChallenge,
          identityUrl,
          tenant
        });
        setCodeVerifier(newCodeVerifier);
        const iframe = document.createElement('iframe');
        iframe.id = _constants.AUTH_IFRAME_ID;
        iframe.src = authUrl;
        iframe.sandbox.add('allow-forms');
        iframe.sandbox.add('allow-scripts');
        iframe.sandbox.add('allow-same-origin');
        iframe.hidden = true;
        iframe.style.visibility = 'hidden';
        iframe.style.display = 'none';
        document.body.append(iframe);
        return () => iframe.remove();
      }).catch(error => {
        localLogger.error(new Error('Generating of a code verifier and a code challenge for PKCE failed', {
          cause: error
        }));
      });
    }
  }, [identityUrl, isAnonymousUser, isUserVerified, localLogger, tenant]);
  const value = (0, _react.useMemo)(() => ({
    codeVerifier
  }), [codeVerifier]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Provider, {
    value: value,
    children: children
  });
};
exports.ExternalAuthProvider = ExternalAuthProvider;
const useExternalAuth = () => (0, _react.useContext)(externalAuthContext);
exports.useExternalAuth = useExternalAuth;
